import { Mail, MessageCircle } from "lucide-react";
import { PUBLIC_EMAIL, WHATSAPP_NUMBER, WHATSAPP_DISPLAY } from "@/lib/constants";
import { LeadForm } from "@/components/landing/LeadForm";
import { SectionLabel } from "@/components/site/FormBits";
import { useSeo, pageSeo } from "@/lib/seo";
import { BookCallButton } from "@/components/site/BookCall";

const SEO = pageSeo("/contact");
const BOOK_SEO = pageSeo("/book-a-call");

export default function ContactPage({ embedded = false }) {
  useSeo(embedded ? BOOK_SEO : SEO);
  return (
    <>
    <div className="bg-[#0B2A4A] text-[#F5ECD7]" data-testid="contact-book-call-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="flex-1 text-sm sm:text-base"><strong className="text-white">Free 20-minute one-on-one with Greg</strong> — find out if becoming a digital nomad is for you. Pick a day and time; Greg confirms on WhatsApp.</p>
        <BookCallButton source="contact-top" light testId="contact-book-call-btn" />
      </div>
    </div>
    <section className="max-w-7xl mx-auto px-4 sm:px-8 py-14 sm:py-20 grid lg:grid-cols-[1fr_1.3fr] gap-12 items-start" data-testid="contact-page">
      <div className="lg:sticky lg:top-28">
        <SectionLabel>Contact</SectionLabel>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#0B2A4A] leading-[1.05]">{embedded ? "Book a Free 20-Minute Call" : "Let's Collaborate"}</h1>
        <h2 className="mt-6 text-base md:text-lg text-slate-700 leading-relaxed font-normal">Whether you're just dreaming about the nomad life or already running your own project — tell me where you are and what you'd love to build. If something clicks, we'll find a way to work together.</h2>
        <p className="mt-6 text-sm text-slate-600 flex items-center gap-2"><Mail className="h-4 w-4 text-[#1A9AA8]" /> Every message goes straight to Mr. Greg, who replies by email, WhatsApp (with your consent), or in the app.</p>
        <div className="mt-6 flex flex-wrap gap-3">
          <a href={`mailto:${PUBLIC_EMAIL}`} className="inline-flex items-center gap-2 rounded-xl bg-[#0B2A4A] text-[#F5ECD7] px-4 py-2.5 text-sm font-semibold hover:bg-[#071C33]" data-testid="contact-email-link"><Mail className="h-4 w-4" /> {PUBLIC_EMAIL}</a>
          <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener" className="inline-flex items-center gap-2 rounded-xl bg-[#25D366] text-white px-4 py-2.5 text-sm font-semibold" data-testid="contact-whatsapp-link"><MessageCircle className="h-4 w-4" /> WhatsApp {WHATSAPP_DISPLAY}</a>
        </div>
        <img src="/brand/esc-clubhouse.jpg" alt="Esc Digital Nomad Village clubhouse at dusk, Popoyo, Nicaragua" className="hidden lg:block mt-10 rounded-3xl h-72 w-full object-cover" />
      </div>
      <div className="bg-white rounded-3xl shadow-xl shadow-[#0B2A4A]/10 border border-[#0B2A4A]/10 p-6 sm:p-10">
        <LeadForm />
      </div>
    </section>
    </>
  );
}
